var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscussionForum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 155C121.421 155 155 121.421 155 80C155 38.5786 121.421 5 80 5C38.5786 5 5 38.5786 5 80C5 121.421 38.5786 155 80 155Z",
    fill: "#DFE3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 32.5C31.3807 32.5 32.5 31.3807 32.5 30C32.5 28.6193 31.3807 27.5 30 27.5C28.6193 27.5 27.5 28.6193 27.5 30C27.5 31.3807 28.6193 32.5 30 32.5Z",
    fill: "#DFE3FF",
    fillOpacity: 0.560784
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 32.5C38.8807 32.5 40 31.3807 40 30C40 28.6193 38.8807 27.5 37.5 27.5C36.1193 27.5 35 28.6193 35 30C35 31.3807 36.1193 32.5 37.5 32.5Z",
    fill: "#DFE3FF",
    fillOpacity: 0.560784
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 32.5C46.3807 32.5 47.5 31.3807 47.5 30C47.5 28.6193 46.3807 27.5 45 27.5C43.6193 27.5 42.5 28.6193 42.5 30C42.5 31.3807 43.6193 32.5 45 32.5Z",
    fill: "#DFE3FF",
    fillOpacity: 0.560784
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9999 13C29.4771 13 24.9999 17.4772 24.9999 23V26.104L17.0406 30.7107C15.6514 31.5148 15.6536 33.5211 17.0445 34.3221L24.9999 38.9038V43C24.9999 48.5228 29.4771 53 34.9999 53H107C112.523 53 117 48.5228 117 43V23C117 17.4772 112.523 13 107 13H34.9999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102 29H38V37H102V29Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 37C44.2091 37 46 35.2091 46 33C46 30.7909 44.2091 29 42 29C39.7909 29 38 30.7909 38 33C38 35.2091 39.7909 37 42 37Z",
    fill: "#032746"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37C58.2091 37 60 35.2091 60 33C60 30.7909 58.2091 29 56 29C53.7909 29 52 30.7909 52 33C52 35.2091 53.7909 37 56 37Z",
    fill: "#032746"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37C72.2091 37 74 35.2091 74 33C74 30.7909 72.2091 29 70 29C67.7909 29 66 30.7909 66 33C66 35.2091 67.7909 37 70 37Z",
    fill: "#032746"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37C86.2091 37 88 35.2091 88 33C88 30.7909 86.2091 29 84 29C81.7909 29 80 30.7909 80 33C80 35.2091 81.7909 37 84 37Z",
    fill: "#032746"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98 37C100.209 37 102 35.2091 102 33C102 30.7909 100.209 29 98 29C95.7909 29 94 30.7909 94 33C94 35.2091 95.7909 37 98 37Z",
    fill: "#032746"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9999 105C26.4771 105 21.9999 109.477 21.9999 115V118.104L14.0406 122.711C12.6514 123.515 12.6536 125.521 14.0445 126.322L21.9999 130.904V135C21.9999 140.523 26.4771 145 31.9999 145H118C123.523 145 128 140.523 128 135V115C128 109.477 123.523 105 118 105H31.9999Z",
    fill: "#032746"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39 129C41.2091 129 43 127.209 43 125C43 122.791 41.2091 121 39 121C36.7909 121 35 122.791 35 125C35 127.209 36.7909 129 39 129Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53 129C55.2091 129 57 127.209 57 125C57 122.791 55.2091 121 53 121C50.7909 121 49 122.791 49 125C49 127.209 50.7909 129 53 129Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67 129C69.2091 129 71 127.209 71 125C71 122.791 69.2091 121 67 121C64.7909 121 63 122.791 63 125C63 127.209 64.7909 129 67 129Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81 129C83.2091 129 85 127.209 85 125C85 122.791 83.2091 121 81 121C78.7909 121 77 122.791 77 125C77 127.209 78.7909 129 81 129Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95 129C97.2091 129 99 127.209 99 125C99 122.791 97.2091 121 95 121C92.7909 121 91 122.791 91 125C91 127.209 92.7909 129 95 129Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109 129C111.209 129 113 127.209 113 125C113 122.791 111.209 121 109 121C106.791 121 105 122.791 105 125C105 127.209 106.791 129 109 129Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 59C144.523 59 149 63.4772 149 69V72.104L156.959 76.7107C158.348 77.5148 158.346 79.5211 156.955 80.3221L149 84.9038V89C149 94.5228 144.523 99 139 99H85C79.4771 99 75 94.5228 75 89V69C75 63.4772 79.4771 59 85 59H139Z",
    fill: "#B10303"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86 75H136V83H86V75Z",
    fill: "#B10303"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132 83C129.791 83 128 81.2091 128 79C128 76.7909 129.791 75 132 75C134.209 75 136 76.7909 136 79C136 81.2091 134.209 83 132 83Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118 83C115.791 83 114 81.2091 114 79C114 76.7909 115.791 75 118 75C120.209 75 122 76.7909 122 79C122 81.2091 120.209 83 118 83Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104 83C101.791 83 100 81.2091 100 79C100 76.7909 101.791 75 104 75C106.209 75 108 76.7909 108 79C108 81.2091 106.209 83 104 83Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9999 83C87.7908 83 85.9999 81.2091 85.9999 79C85.9999 76.7909 87.7908 75 89.9999 75C92.209 75 93.9999 76.7909 93.9999 79C93.9999 81.2091 92.209 83 89.9999 83Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7444 93.7701C60.7444 94.8747 59.8489 95.7701 58.7444 95.7701H52.7566C51.6521 95.7701 50.7566 94.8747 50.7566 93.7701V93.6737C50.7566 85.3791 55.7955 81.0951 60.5644 77.358C64.6135 74.0766 68.3027 70.9775 68.3027 65.6909C68.3027 59.4927 64.5235 55.391 58.2249 55.391C52.4617 55.391 48.3095 59.3225 47.5518 65.2449C47.4117 66.3405 46.532 67.2404 45.4274 67.2404H38C36.8954 67.2404 35.9914 66.3413 36.0757 65.2399C36.9918 53.274 46.1259 45 58.4949 45C71.9018 45 80 52.8388 80 64.9617C80 74.7147 73.7914 79.3633 68.5726 83.1004C64.1636 86.2906 60.7444 89.0251 60.7444 93.6737V93.7701ZM56.1554 114C52.1063 114 48.8671 110.719 48.8671 106.799C48.8671 102.789 52.1063 99.5073 56.1554 99.5073C60.1145 99.5073 63.4438 102.789 63.4438 106.799C63.4438 110.627 60.1145 114 56.1554 114Z",
    fill: "#032746"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussionForum);
export default __webpack_public_path__ + "static/media/Discussion_forum.a7b1ea5d94620552b2b47643aa9f6f33.svg";
export { ForwardRef as ReactComponent };